import { Switch } from "@mui/material";
import "./NotificationsPage.css";
import Messages from "../../localization/Messages";
import { useIntl } from "react-intl";
import RpisPage from "../RpisPage/RpisPage";
import NotificationsContainer from "../../components/NotificationsContainer/NotificationsContainer";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { useFetchNotifications } from "../../../src/hooks/useFetchNotifications";
import { useMemo } from "react";

/**
 * Represents the Notifications page.
 * This page displays notifications to the user.
 *
 * @component
 * @example
 * return <NotificationsPage />;
 */
export const NotificationsPage = () => {
    const intl = useIntl();
    const { data: notificationData } = useFetchNotifications({});

    const [showOnlyUnread, setShowOnlyUnread] = useLocalStorage(
        "showOnlyUnreadNotifications",
        true,
    );

    const notifications = useMemo(() => {
        if (notificationData && notificationData.length > 0) {
            return showOnlyUnread
                ? notificationData.filter(({ read }: { read: boolean }) => !read)
                : notificationData;
        }
        return [];
    }, [notificationData, showOnlyUnread]);

    return (
        <RpisPage title={intl.formatMessage(Messages.notifications)}>
            <div className="notifications-page-container">
                <div className="notifications-wrapper">
                    <div className="title-and-actions">
                        <div className="title-section">
                            <h3>{intl.formatMessage(Messages.notifications)}</h3>
                        </div>
                        <div className="actions-section">
                            <span className="switch-label">
                                {intl.formatMessage(Messages.onlyShowUnread)}
                            </span>
                            <Switch
                                size="small"
                                checked={showOnlyUnread}
                                onChange={() => setShowOnlyUnread(current => !current)}
                            />
                        </div>
                    </div>
                    <NotificationsContainer notifications={notifications} />
                </div>
            </div>
        </RpisPage>
    );
};

export default NotificationsPage;
